import useAction from '@hooks/useAction';
import useProcess from '@hooks/useProcess';
import { useWorkflow } from '@hooks/useWorkflow';
import { TableImporterConfig as Config } from '@panel/components/action/tableImporter/tableImporter.config';
import PanelHeader from '@panel/PanelHeader';
import { PanelBody } from '@panel/panel.style';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { ParamsList } from '@/routes/routes.types';

export const TableEditorPanel = observer(() => {
  const actionId = useParams<string>()[ParamsList.ActionId] as string;
  const process = useProcess();
  const { workflow } = useWorkflow();
  const action = useAction();

  useEffect(() => {
    const bpmn = workflow?.bpmn;
    if (!bpmn) {
      return;
    }
    bpmn.setSelectedElementByElementId(actionId);
    return () => bpmn.resetSelectedElement();
  }, [actionId, workflow?.bpmn]);

  if (!(process && workflow)) {
    return <></>;
  }

  return (
    <>
      <PanelHeader
        actionType="Table editor"
        infos={[action?.name ?? 'Error action']}
        tabLinks={Config.TAB_LINKS}
        workflowName={workflow.name ?? 'Error WF'}
      />

      <PanelBody>
        <Outlet />
      </PanelBody>
    </>
  );
});
